import { message, Modal, Tabs } from 'antd';
import { t } from 'i18next';
// import List from 'pages/timbre_replication_management/components/List';
import { useCallback, useEffect, useState } from 'react';
import List from './List';
import { SystemDictType } from 'types/index';
import { VoiceType, TimbreItem, SpeedItem } from 'pages/image_configure/types';
import './index.scss';
import { useTry } from './ttsTryout/useTry';
import { getThirdPartyTimbreKeyList } from 'apis';
interface Iprops {
  visible: boolean;
  onCancel?: () => void;
  isTabShow: boolean;
  type?: string;
  value: VoiceType;
  speedList?: SpeedItem[];
  modelSource: string;
  timbreCategoryEnum: SystemDictType[];
  timbreLangugeList?: SystemDictType[];
  timbreAuditionTextList: SystemDictType[];
  disabled?: boolean;
  virtualmanTypeCode: string;
  limit?: number;
  virtualmanResourceId?: number;
  virtualmanCode?: string;
  onValueChange?: Function;
  isInitializing?: boolean;
  fastVoiceSpeedWarn?: boolean;
  isBroadcast?: boolean;
  isShowVariable?: boolean;
  onChangeTimer?: (isGoogle: boolean) => Promise<void>;
  onChangeTimbre?: Function;
}
const TimbreSelect = (props: Iprops) => {
  const { visible, onCancel, value, onValueChange, onChangeTimer, onChangeTimbre, isBroadcast } = props;
  const [open, setOpen] = useState(visible);
  const [curSelect, setCurSelect] = useState(value);
  const [tabKey, setTabKey] = useState(value.timbreDetail?.timbreClassification || 1);
  const [secretDialogVisible, setSecretDialogVisible] = useState(false);
  const [secretLoading, setSecretLoading] = useState(false);
  useEffect(() => {
    setCurSelect(value);
  }, [value]);
  const tryout = useTry();
  const { reset } = tryout;

  const onSelect = (value: any) => {
    setCurSelect(value);
  };
  useEffect(() => {
    setOpen(visible);
  }, [visible]);
  const tabList = [
    {
      key: 1,
      value: 1,
      label: t('公共音色'),
    },
    {
      key: 2,
      value: 2,
      label: t('我的音色'),
    },
    {
      value: 3,
      key: 3,
      label: t('三方音色'),
    },
    {
      value: 4,
      key: 4,
      label: t('我的收藏'),
    },
  ];
  const handleCancel = () => {
    setOpen(false);
    onCancel?.();
    reset();
  };
  const handleOk = async () => {
    const { timbreClassification, thirdSource = '' } = curSelect?.timbreDetail || {};
    if (timbreClassification === 3) {
      setSecretLoading(true);
      const res = await getThirdPartyTimbreKeyList({
        source: thirdSource,
        keyType: 1,
      });
      setSecretLoading(false);
      const { thirdPartySecretList } = res;
      const curSource = thirdPartySecretList?.find((i) => i.source === thirdSource);
      if (!curSource || !curSource.secretInfo) {
        setSecretDialogVisible(true);
        return;
      }
      const secretInfo = JSON.parse(curSource.secretInfo || '{}');
      if( thirdSource === 'tencent' && (!secretInfo.app_id || !secretInfo.secret_id || !secretInfo.secret_key) ) {
        setSecretDialogVisible(true);
        return;
      }
      if( thirdSource === 'azure' && (!secretInfo.subscription_key || !secretInfo.region) ) {
        setSecretDialogVisible(true);
        return;
      }
    }
    if (
      (curSelect?.timbreDetail?.platformSource !== value?.platformSource &&
        curSelect?.timbreDetail?.platformSource === 5) ||
      (curSelect?.timbreDetail?.thirdSource === 'google' &&
        curSelect?.timbreDetail?.thirdSource !== value?.timbreDetail?.thirdSource)
    ) {
      try {
        await onChangeTimer?.(curSelect?.timbreDetail?.thirdSource === 'google');
      } catch (error) {
        return;
      }
    }
    onChangeTimbre?.(curSelect);
    onValueChange?.({
      timbreCode: curSelect.timbreCode,
      timbreName: curSelect.timbreName,
      language: curSelect.language,
      emotionCategory: curSelect.emotionCategory,
      emotionalStyles: curSelect.timbreDetail?.emotionalStyles,
      supportLanguages: curSelect.timbreDetail?.supportLanguages,
      ...curSelect.timbreDetail,
      timbreLanguage: curSelect.timbreLanguage,
      timbreDetail: curSelect.timbreDetail,
    });
    isBroadcast && onCancel?.();
    reset();
  };
  return (
    <Modal
      title={t('请选择音色')}
      visible={open}
      onOk={handleOk}
      onCancel={handleCancel}
      centered
      width="auto"
      className="timbre-select-modal"
      maskClosable={false}
      confirmLoading={secretLoading}
    >
      <Modal
        title={t('该三方音色未配置密钥')}
        visible={secretDialogVisible}
        onOk={() => {
          window.open(`/ivh/#/asserts_management?thirdSource=${curSelect?.timbreDetail?.thirdSource}`);
          setSecretDialogVisible(false);
        }}
        okText={t('前往')}
        onCancel={() => {
          setSecretDialogVisible(false);
        }}
        centered
        width={480}
        maskClosable={false}
      >
        <div>{t('请前往资产管理中心完成密钥的完整配置。')}</div>
      </Modal>
      <Tabs
        defaultActiveKey={String(value.timbreDetail?.timbreClassification) || '1'}
        onChange={(value) => {
          setTabKey(Number(value));
        }}
        className="header-tab"
      >
        {tabList.map((item) => (
          <Tabs.TabPane tab={item.label} key={item.key}>
            {tabKey === item.key && (
              <List
                onSelect={onSelect}
                payload={{
                  ...props,
                }}
                value={{
                  ...value,
                  timbreCode: curSelect?.timbreCode,
                  emotionCategory: curSelect?.emotionCategory,
                  timbreLanguage: curSelect?.timbreLanguage,
                }}
                tryout={tryout}
                tabKey={tabKey}
                key={item.key}
                itemKey={item.key}
              />
            )}
          </Tabs.TabPane>
        ))}
      </Tabs>
    </Modal>
  );
};
export default TimbreSelect;
